module.exports = __webpack_public_path__ + "media/media/logos/google-d566c7a6fb6545521fec150436fa45a6.png";